// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"1cf7aba2","344":"b2eb980e"}[chunkId] + ".chunk.css";
};